import { Button, Grid } from '@material-ui/core';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getType } from 'typesafe-actions';
import {
  ResponsiveCard,
  ResponsiveCardActions,
  ResponsiveCardContent,
} from '../../../../../../common/components/cards';
import { PasswordTextField } from '../../../../../../common/components/fields';
import Logo from '../../../../../../common/components/Logo';
import { groupLoginActions } from '../login.actions';
import {
  GroupLoginDto,
  groupLoginInit,
  groupLoginValidationSchema,
} from '../login.dtos';

interface IProps {
  id: string;
}

const GroupVisitLoginForm: React.FC<IProps> = ({ id }) => {
  const dispatch = useDispatch();

  const [dto, setDto] = useState<GroupLoginDto>(groupLoginInit);

  return (
    <ResponsiveCard>
      <Logo />
      <Formik
        initialValues={dto}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={groupLoginValidationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setTimeout(() => {
            setSubmitting(false);
            resetForm();
          }, 700);

          values.groupId = id;

          dispatch({
            type: getType(groupLoginActions.request),
            payload: values,
          });
        }}
        enableReinitialize={true}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleSubmit,
          } = props;
          return (
            <form onSubmit={handleSubmit}>
              <ResponsiveCardContent>
                <Grid container>
                  <Grid item xs={12}>
                    <PasswordTextField
                      size='small'
                      margin='normal'
                      name='password'
                      fullWidth
                      value={values.password}
                      label='Password'
                      autoComplete='password'
                      onChange={handleChange}
                      error={Boolean(errors.password)}
                      helperText={
                        errors.password && touched.password && errors.password
                      }
                      required
                    />
                  </Grid>
                </Grid>
              </ResponsiveCardContent>

              <ResponsiveCardActions>
                <Grid container justify='flex-end' alignItems='center'>
                  <Button
                    color='secondary'
                    variant='text'
                    disabled={isSubmitting}
                    type='submit'
                    data-cy='login'
                  >
                    Login
                  </Button>
                </Grid>
              </ResponsiveCardActions>
            </form>
          );
        }}
      </Formik>
    </ResponsiveCard>
  );
};

export default GroupVisitLoginForm;
